import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, RocketIcon, BotIcon } from 'lucide-react';
const bonuses = [{
  icon: <FileTextIcon className="w-6 h-6 text-gold" data-id="element-11" />,
  title: 'Scripts de Atención y Cierre de Clientes',
  desc: 'Guiones para consultas, honorarios, objeciones y seguimiento.',
  value: '$9.990'
}, {
  icon: <RocketIcon className="w-6 h-6 text-gold" data-id="element-12" />,
  title: 'Plan "Primeros 30 Días"',
  desc: 'Plan semanal paso a paso para implementar todo el sistema.',
  value: '$7.990'
}, {
  icon: <BotIcon className="w-6 h-6 text-gold" data-id="element-13" />,
  title: 'Guía de Uso de IA para Abogados',
  desc: 'Prompts listos para redactar escritos y automatizar respuestas.',
  value: '$5.990'
}];
export function BonusesSection() {
  return <section className="bg-navy-dark py-8 md:py-20 px-4 relative" data-id="element-14">
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6 md:mb-10" data-id="element-16">
          <div className="inline-block bg-red-600 text-white font-bold px-4 py-1.5 rounded-full mb-3 md:mb-5 animate-pulse text-xs md:text-sm" data-id="element-17">
            ⚠️ ATENCIÓN
          </div>
          <h2 className="text-xl md:text-4xl font-black text-white mb-2" data-id="element-18">
            🎁 BONOS EXCLUSIVOS —{' '}
            <span className="text-gold" data-id="element-19">¡GRATIS HOY!</span>
          </h2>
          <p className="text-sm md:text-lg text-gray-300" data-id="element-20">
            Material adicional sin costo extra si ordenás hoy.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-3 md:gap-4" data-id="element-21">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-navy-light p-4 md:p-5 rounded-lg md:rounded-xl border border-gold/30 flex flex-col" data-id="element-22">
              <div className="flex items-center gap-2 mb-2" data-id="element-23">
                <div className="bg-navy-dark p-1.5 md:p-2 rounded-lg border border-gold/20" data-id="element-24">
                  {bonus.icon}
                </div>
                <h3 className="text-sm md:text-base font-bold text-white leading-tight" data-id="element-25">
                  {bonus.title}
                </h3>
              </div>
              <p className="text-gray-400 text-xs md:text-sm mb-3 flex-grow" data-id="element-26">
                {bonus.desc}
              </p>
              <div className="pt-2 border-t border-gray-800 flex items-center justify-between" data-id="element-27">
                <span className="text-red-400 line-through text-xs md:text-sm font-bold" data-id="element-28">
                  {bonus.value}
                </span>
                <span className="text-green-400 font-black text-xs md:text-sm" data-id="element-29">
                  ¡HOY GRATIS!
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}